import React from 'react'
import { connect } from 'react-redux'

import Surveys from './Surveys'
import { fetchSurveysList } from './actions'


class SurveysList extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let date = new Date()

        let endDate = date.getFullYear() + "-"

        var day = date.getDate()
        var month = date.getMonth() + 1

        if (month < 10) {
             endDate = endDate + "0" + month + "-"
        }
        else {
             endDate = endDate + month + "-"
        }

        if (day < 10) {
             endDate = endDate + "0" + day
        }
        else {
            endDate = endDate + day
        }

        let surveys = {
            startDate: '1901-01-01',
            endDate: endDate,
            reportingCategory: 'reico_company_score',
            category: 'Reico Company Scores'
        }

        fetchSurveysList.bind(this)(surveys)
    }

    render() {
        return (
            <Surveys surveysList={this.props.surveys.surveysList.surveys} />
        );
    }
}

const mapStateToProps = state => ({
    surveys: state.surveys
});

export default connect(mapStateToProps)(SurveysList)
